export default {
  container: {
    //width: "100%"
    borderRadius: 10,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "white"
  },
  dropdown: {
    height: 40
  },
  rowContainerStyles: {
    flexDirection: "row",
    display: "flex",
    borderBottomWidth: 1,
    borderBottomColor: "#b4b4b8",
    marginTop: 10,
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 10
  },
  selectedTabStyles: {
    borderBottomWidth: 4,
    borderBottomColor: "#dac96b",
    marginRight: 35
  },
  defaultTabStyles: {
    marginRight: 35,
    cursor: "pointer"
  },
  defaultTextColor: {
    color: "#b4b4b8"
  }
};